import type { MailboxInfo } from 'owa-client-types';
import type NotificationPayloadBase from 'owa-service/lib/contract/NotificationPayloadBase';
import { action } from 'satcheljs';

export interface AGENTMESSAGES_NOTIFICATIONActionMessage {
    notification: NotificationPayloadBase;
    mailboxInfo: MailboxInfo;
}
const defaultExport: (
    notification: NotificationPayloadBase,
    mailboxInfo: MailboxInfo
) => AGENTMESSAGES_NOTIFICATIONActionMessage = action(
    'AGENTMESSAGES_NOTIFICATION',
    (
        notification: NotificationPayloadBase,
        mailboxInfo: MailboxInfo
    ): AGENTMESSAGES_NOTIFICATIONActionMessage => ({
        notification,
        mailboxInfo,
    })
);
export default defaultExport;
